import { IdAndNameOf } from './IApiBaseResource';
import { IApiServer } from './IApiServer';
import { IApiStream } from './IApiStream';
import { IApiSymbol } from './IApiSymbol';
import { IApiClientSymbol } from './IApiClientSymbol';
import { IApiProfileBase } from './IApiProfileBase';

export type IApiRuleClientSymbol = IApiClientSymbol['name'];

export interface IApiRuleValidationError {
  code: ApiRuleErrorCode;
  key: ApiRuleErrorKey;
  ref: (number | string)[] | string | number;
}

export enum ApiRuleErrorCode {
  NotFound = 'notFound',
}

export enum ApiRuleErrorKey {
  CoreSymbol = 'coreSymbol',
  ClientSymbol = 'clientSymbol',
  ProfileId = 'profileId',
  ServerId = 'serverId',
  StreamId = 'streamId',
  SymbolGroup = 'symbolGroup',
}

export enum ApiRuleWarningKey {
  StreamId = 'streamId',
  SymbolGroup = 'symbolGroup',
  CoreSymbol = 'coreSymbol',
  ClientSymbol = 'clientSymbol',
}

export enum ApiRuleWarningNoMapping {
  ServerId = 'serverId',
  StreamId = 'streamId',
  CoreSymbol = 'coreSymbol',
  ClientSymbol = 'clientSymbol',
}

export interface IApiRuleUselessWarningItem {
  key: ApiRuleWarningKey;
  noMapping: ApiRuleWarningNoMapping;
}

export interface IApiRuleWarningsUnused {
  unused: boolean;
}

export interface IApiRuleWarningsUseless {
  useless: IApiRuleUselessWarningItem[];
}

export type IApiRuleWarnings = IApiRuleWarningsUnused | IApiRuleWarningsUseless;

export interface IApiRuleWithError {
  index: number;
  errors?: IApiRuleValidationError[];
}

export interface IApiRuleWithWarning {
  index: number;
  warnings?: IApiRuleWarnings;
}

export interface IApiBasicRule {
  profile: IApiProfileBase;
  coreSymbols?: IdAndNameOf<IApiSymbol>[];
  server?: IdAndNameOf<IApiServer>;
  stream?: IdAndNameOf<IApiStream>;
  symbolGroup?: string;
  errors?: IApiRuleValidationError[];
  warnings?: IApiRuleWarnings;
}

export interface IApiClientRule extends IApiBasicRule {
  clientSymbols?: IApiRuleClientSymbol[];
}

export interface IApiBasicRuleUpdate {
  coreSymbols?: IApiSymbol['id'][];
  profileId: IApiProfileBase['id'];
  serverId?: IApiServer['id'];
  streamId?: IApiStream['id'];
  symbolGroup?: string;
}

export interface IApiClientRuleUpdate extends IApiBasicRuleUpdate {
  clientSymbols?: IApiClientSymbol['name'][];
}

export interface IApiRuleId {
  id?: number;
}
